import { getWidgetSettings } from '@wix/ambassador-innovation-widget-v1-widget-settings/http';

import { createAppAsyncThunk } from '../createAppAsyncThunk';

import { settingsSlice } from './settingsSlice';
import { formatSettingsResponse } from './utils';

export const getSettings = createAppAsyncThunk(
  'settings/get',
  async (_, { dispatch, extra: { httpClient } }) => {
    const resp = await httpClient.request(getWidgetSettings({}));
    if (resp.status === 200) {
      dispatch(settingsSlice.actions.set(formatSettingsResponse(resp.data)));
    }
  },
);
